// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__IW7jl","inner":"Footer_inner__5C0vi","nextIcon":"Footer_nextIcon__2tFIv","innerLeft":"Footer_innerLeft__1Jlku"};